import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnDestroy,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CommonService } from "app/reusable/common.service";
import { MDMService } from "app/reusable/mdm.service";
import { CedNotificationService } from "ced-ng-library";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-update-policy-control",
  templateUrl: "./update-policy-control.component.html",
  styleUrls: ["./update-policy-control.component.scss"],
})
export class UpdatePolicyControlComponent implements OnInit, OnDestroy {
  @Input() policycontrol;
  public policyControlForm: FormGroup;
  @Input() PolicyExceptionList = [];
  @Output() policyControlChanged: EventEmitter<any> = new EventEmitter();
  policy: any[] = [
    { id: 1, name: "Vecozo" },
    { id: 2, name: "PIA" },
    { id: 3, name: "Both" },
  ];
  public ClientExist: boolean = false;
  public dataSource: any[] = [];
  private _subject$: Subject<boolean> = new Subject();

  constructor(private mdmService: MDMService, private cedNotificationService: CedNotificationService) { }

  ngOnInit(): void {
    this.initForm();
    this.getOrganizationUnit();
  }

  getOrganizationUnit(): void {
    const GetClientsListUrl: string = `api/OrganizationUnit/GetInsurersAndMandates`;
    this.mdmService.getData(GetClientsListUrl,true).pipe(takeUntil(this._subject$)).subscribe((data: any) => {
      this.dataSource = data;
      this.dataSource = this.dataSource.filter((cl) => cl.shortName != null && cl.shortName != "");
      this.dataSource = this.dataSource.sort((a, b) => a.shortName.toLowerCase() > b.shortName.toLowerCase() ? 1 : -1);
      this.policyControlForm.controls["ouId"].setValue(
        this.policycontrol.cpcOrganizationunitId
      );
      this.policyControlForm.controls["cpcCheckMethodId"].setValue(
        this.policycontrol.cpcCheckMethodId
      );
    },
    (error) => {
      this.cedNotificationService.warning("NOTIFICATIONS.GET_ORGANIZATION_UNIT");
    });
  }

  checkClient($event): void {
    this.ClientExist = this.PolicyExceptionList.some(
      (el) => el.cpcOrganizationunitId == $event
    );
  }

  initForm(): void {
    this.policyControlForm = new FormGroup({
      ouId: new FormControl("", [Validators.required]),
      cpcCheckMethodId: new FormControl("", [Validators.required]),
    });
  }

  public cancel(): void {
    this.policyControlChanged.emit(null);
  }

  save(): void {
    this.policyControlForm.markAllAsTouched();
    if (this.policyControlForm.valid && !this.ClientExist) {
      let params = {
        cpcId: this.policycontrol.cpcId,
        cpcCaseTypeId: this.policycontrol.cpcCaseTypeId,
        cpcCheckMethodId: this.policyControlForm.controls["cpcCheckMethodId"]
          .value,
        cpcOrganizationunit: this.dataSource.find(
          (cl) => cl.id == this.policyControlForm.controls["ouId"].value
        ),
        cpcOrganizationunitId: this.policyControlForm.controls["ouId"].value,
      };
      let ouShortName = params.cpcOrganizationunit.shortName;
      delete Object.assign(params.cpcOrganizationunit, {'ouShortName': this.dataSource['shortName'] })['shortName'];
      params.cpcOrganizationunit.ouShortName = ouShortName;
      this.policyControlChanged.emit(params);
    }
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}
